<template>
  <div>
    <b-navbar toggleable="md" type="dark" class="bg-teal navbar-finult">
      <b-navbar-brand href="/" style="background-color: transparent;">
        <img
          class="img-fluid"
          id="logo"
          alt="Finult"
          src="../assets/images/logo_only.png"
        />
        <img
          class="img-fluid"
          id="logo"
          alt="Finult"
          src="../assets/images/finult_Logo.png"
        />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <div v-for="navItem in navBarMenu" :key="navItem.id">
            <!--Check if nav Item if Text  -->
            <div v-if="navItem.menuType === 'Text'">
              <!--Check if path exists , means this href attribute -->
              <div v-if="navItem.path">
                <b-nav-item :href="navItem.path">{{ navItem.name }}</b-nav-item>
              </div>
              <!-- Else is considered for :to attribute passing the componenet name-->
              <div v-else>
                <b-nav-item :to="{ name: navItem.componentName }">{{
                  navItem.name
                }}</b-nav-item>
              </div>
            </div>
            <!-- Else is considered as dropdown-->
            <div v-else>
              <b-nav-item-dropdown :text="navItem.name" right>
                <b-dropdown-item
                  v-for="dropdownItem in navItem.menuDropdown"
                  :to="{ name: dropdownItem.componentName }"
                  :key="dropdownItem.id"
                >
                  {{ dropdownItem.name }}
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </div>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import Navbar from "@/components/json/NavbarMenu";
export default {
  name: "Nabvar",
  data() {
    return {
      navBarMenu: []
    };
  },
  created() {
    this.navBarMenu = Navbar.navBarMenu;
  }
};
</script>

<style>
.navbar-finult,
.dropdown-menu,
.bg-teal,
.navbar-nav .nav-link,
a.dropdown-item {
  color: #f2fbfc!important;
  background-color: #37a3b8!important;
  font-weight: bold;
}

.nav-item:hover,
.nav-item .active,
.dropdown-item .active,
.dropdown-item:hover,
nav li:hover,
nav li.router-link-active,
nav li.router-link-exact-active,
.nav-item:hover,
.nav-item .active,
.nav-link .active,
.nav-link:hover {
  color: #333333 !important;
  background-color: #ffdb58 !important;
  font-weight: bold;
}
</style>
